import React from 'react';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaInstagram } from 'react-icons/fa';

import './SocialMedia.scss';

const SocialMedia = ({
  iconsToDisplay = [],
  color = 'regular',
  linkType = 'follow',
  location = 'https://www.profilepensions.co.uk',
}) => {
  const icons = {
    facebook: {
      icon: <FaFacebookF />,
      link: {
        follow: 'https://www.facebook.com/ProfilePensions/',
        share: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`https://profilepensions.co.uk${location}`)}`,
      },
    },
    linkedin: {
      icon: <FaLinkedinIn />,
      link: {
        follow: 'https://www.linkedin.com/company/profile-financial-solutions-ltd/',
        share: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(`https://profilepensions.co.uk${location}`)}`,
      },
    },
    twitter: {
      icon: <FaTwitter />,
      link: {
        follow: 'https://twitter.com/profilepensions',
        share: `https://twitter.com/intent/tweet?text=${encodeURIComponent(`https://profilepensions.co.uk${location}`)}`,
      },
    },
    youtube: {
      icon: <FaYoutube />,
      link: {
        follow: 'https://www.youtube.com/channel/UCKHQgf2MbLUDhI5mJztgcpA/',
        share: '',
      },
    },
    instagram: {
      icon: <FaInstagram />,
      link: {
        follow: 'https://www.instagram.com/profilepensions/',
        share: '',
      },
    },
  };

  return (
    <div className="social-icons-wrapper">
      {
        iconsToDisplay && iconsToDisplay.map((iconName) => {
          if (icons[iconName]) {
            return (
              <a className={`social-icon ${iconName}`} key={iconName} href={icons[iconName].link[linkType]} rel="nofollow noreferrer noopener" target="_blank">
                {icons[iconName].icon}
              </a>
            );
          }

          return null;
        })
      }
    </div>
  );
};

export default SocialMedia;
